"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var gatsby_link_2 = require("gatsby-link");
var semantic_ui_react_4 = require("semantic-ui-react");
var BlogTitle_2 = require("../components/BlogTitle");
var TagsCard_1 = require("../components/TagsCard/TagsCard");
var BlogPagination_1 = require("../components/BlogPagination/BlogPagination");
exports.default = function (props) {
  var tags = props.data.tags.group;
  var posts = props.data.posts.edges;
  var pathname = props.location.pathname;

  var pageCount = Math.ceil(props.data.posts.totalCount / 10);
  // TODO export posts in a proper component
  var Posts = React.createElement(semantic_ui_react_4.Container, null, posts.map(function (_ref) {
    var node = _ref.node;
    var frontmatter = node.frontmatter,
        timeToRead = node.timeToRead,
        slug = node.fields.slug,
        excerpt = node.excerpt;

    var avatar = frontmatter.author.avatar.children[0];
    var cover = frontmatter.image.children[0];
    var extra = React.createElement(semantic_ui_react_4.Comment.Group, null, React.createElement(semantic_ui_react_4.Comment, null, React.createElement(semantic_ui_react_4.Comment.Avatar, { src: avatar.responsiveResolution.src, srcSet: avatar.responsiveResolution.srcSet }), React.createElement(semantic_ui_react_4.Comment.Content, null, React.createElement(semantic_ui_react_4.Comment.Author, { style: { fontWeight: 400 } }, frontmatter.author.id), React.createElement(semantic_ui_react_4.Comment.Metadata, { style: { margin: 0 } }, frontmatter.updatedDate, " - ", timeToRead, " min read"))));
    var description = React.createElement(semantic_ui_react_4.Card.Description, null, excerpt, React.createElement("br", null), React.createElement(gatsby_link_2.default, { to: slug }, "Read more\u2026"));
    return React.createElement(semantic_ui_react_4.Card, { key: slug, fluid: true, image: {
        src: cover.responsiveResolution.src,
        srcSet: cover.responsiveResolution.srcSet
      }, header: frontmatter.title, extra: extra, description: description });
  }));
  return React.createElement(semantic_ui_react_4.Container, null, React.createElement(BlogTitle_2.default, null), React.createElement(semantic_ui_react_4.Segment, { vertical: true }, React.createElement(semantic_ui_react_4.Grid, { padded: true, style: { justifyContent: "space-around" } }, React.createElement("div", { style: { maxWidth: 600 } }, Posts, React.createElement(semantic_ui_react_4.Segment, { vertical: true, textAlign: "center" }, React.createElement(BlogPagination_1.default, { Link: gatsby_link_2.default, pathname: pathname, pageCount: pageCount }))), React.createElement("div", null, React.createElement(TagsCard_1.default, { Link: gatsby_link_2.default, tags: tags, tag: props.pathContext.tag })))));
};
exports.pageQuery = "** extracted graphql fragment **";


// WEBPACK FOOTER //
// ./~/babel-loader/lib?{"presets":["babel-preset-env"],"plugins":["/opt/build/repo/~/gatsby/dist/utils/babel-plugin-extract-graphql.js"]}!./~/ts-loader!./src/pages/blog.tsx